import * as React from 'react';
import { Image } from '@cian/ui-kit';

import * as styles from './ChatMessageChatbotGreeting.css';
import { useMessageText } from '../../containers/ChatMessageContainer/hooks';
import { EMessageType } from '../../types/messageType';
import { useMessageContext } from '../../utils/messageContext';
import { ImageWithTextMessageLayout } from '../ImageWithTextMessageLayout';

export const ChatMessageChatbotGreeting: React.FC = () => {
  const { message, messageId, messageType, chatId, isLastInChain, messageRef } = useMessageContext();

  const { images } = message;

  const formattedText = useMessageText({ message, messageId, messageType, chatId });

  const imageSrc = images?.[0];

  return (
    <ImageWithTextMessageLayout
      messageType={EMessageType.Incoming}
      isLastMessageInChain={isLastInChain}
      imageMessage={
        imageSrc && (
          <div className={styles['image']}>
            <Image src={imageSrc} width={254} />
          </div>
        )
      }
      textMessage={<div className={styles['text']}>{formattedText}</div>}
      errorSign={null}
      errorText={null}
      messageMeta={null}
      actionButtons={null}
      replyQuote={null}
      ref={messageRef}
    />
  );
};
